export { trackEvent, AnalyticsEvents } from './events'
// getPostHog / useFeatureFlag intentionally not re-exported — import them
// from their concrete modules ('@/utils/analytics/posthog',
// '@/utils/analytics/use-feature-flag') so the 'use client' hook never rides
// along into server bundles via this barrel.
